module.exports = __webpack_public_path__ + "static/media/result.849ae525.png";